import { render } from "./phonehead.vue?vue&type=template&id=f1fe49f6&scoped=true"
import script from "./phonehead.vue?vue&type=script&lang=js"
export * from "./phonehead.vue?vue&type=script&lang=js"

import "./phonehead.vue?vue&type=style&index=0&id=f1fe49f6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fe49f6"]])

export default __exports__